



















































import { Component, Vue, Prop } from "vue-property-decorator";
import { domain, User } from "@/domain";
import * as util from "@/util";
import { UploadPromise } from "@/domain/backend";

@Component
export default class Upload extends Vue {
  @Prop({ default: 1000 }) messageDuration!: number;
  @Prop({ default: 4000 }) errorDuration!: number;
  @Prop({ default: "Subir archivo" }) label!: string;
  @Prop({ default: "image/*" }) fileFilter!: string;
  @Prop({ default: "primary" }) color!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false, required: false }) small?: boolean;
  @Prop({ default: false, required: false }) depressed?: boolean;
  @Prop({ default: false, required: false }) flat?: boolean;
  @Prop({ default: null, required: false }) maxSizeKB?: number;
  @Prop({ default: true }) block!: boolean;
  @Prop({ default: true }) hint!: boolean;

  readyToUpload = true;
  transferred = 0;
  total = 0;
  fileError = "";
  uploadTask: UploadPromise | null = null;
  canceled = false;

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  get inputFile() {
    return this.$refs.inputFile as HTMLInputElement;
  }

  openFileInput() {
    this.inputFile.click();
  }

  reset() {
    util.log("Upload reset");
    this.transferred = 0;
    this.total = 0;
    this.fileError = "";
    this.uploadTask = null;
    this.canceled = false;
    this.readyToUpload = true;
    this.inputFile.value = "";
  }

  clearMessage() {
    setTimeout(
      () => {
        this.reset();
      },
      this.fileError ? this.errorDuration : this.messageDuration
    );
  }

  cancel() {
    if (this.uploadTask) {
      this.canceled = true;
      this.uploadTask.cancel();
    }
  }

  get maxSizeMB() {
    if (!this.maxSizeKB) return null;
    return this.maxSizeKB / 1024;
  }

  setFileError(errorMsg: string) {
    this.fileError = errorMsg;
    this.clearMessage();
  }

  async onFileChanged() {
    try {
      this.fileError = "";
      const files = this.inputFile.files;
      if (!files || files.length === 0) {
        util.log("No files to upload");
        return;
      }
      util.log("Uploading files");
      this.readyToUpload = false;
      this.total = 0;
      const file: File = files[0];
      const fname = file.name;
      const mimeType = file.type;
      if (!!this.maxSizeKB && file.size > this.maxSizeKB * 1024) {
        this.setFileError(`${this.lang.fileToBig} ${this.maxSizeMB}MB.`);
        return;
      }
      const fileRef = await this.uploadToStorage(fname, file);
      if (!fileRef) return;
      this.clearMessage();
      this.$emit("upload", fileRef, fname, mimeType);
    } catch (err) {
      util.logError("Error uploading file", err);
      if (this.canceled) {
        this.setFileError(this.lang.cancelled2);
      } else {
        this.setFileError(this.lang.couldNotUploadFile);
      }
      this.$emit("error", err);
    }
    this.uploadTask = null;
  }

  async uploadToStorage(fname: string, file: File): Promise<string | null> {
    if (!this.currentUser) {
      this.setFileError(this.lang.invalidUser);
      return null;
    }
    const uid = this.currentUser.uid;
    const fileRef = domain.backend.makeTempUploadRef(uid, fname);
    const uploadTask = domain.backend.uploadToStorage(fileRef, file, (transferred, total) => {
      this.transferred = transferred;
      this.total = total;
    });
    this.uploadTask = uploadTask;
    await uploadTask.promise;
    return fileRef;
  }
}
